import React from 'react';
import MainLayOut from '../layout/MainLayOut';

const ReturnPolicy = () => {
  return (
    <>
      <MainLayOut>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-gray-800 leading-7">

          <header className="text-center mb-10">
            <h1 className="text-3xl sm:text-4xl font-semibold">
              Return and Refund Policy – MPI Virgin Plastic
            </h1>
            <h2 className="text-xl font-semibold mt-3">
              Return, Replacement & Refund Policy
            </h2>
          </header>

          <section className="space-y-6 text-justify">
            <h3 className="text-lg font-semibold">Last updated: 20/10/2025</h3>

            <p>
              Thank you for shopping with <strong>MPI Virgin Plastic</strong>. 
              We want you to be fully satisfied with your purchase. If you are not happy 
              with your order, you may request a return, replacement, or refund under the 
              terms below.
            </p>

            {/* 1. Return Window */}
            <section>
              <h3 className="text-lg font-semibold mt-6">1. Return Window & Eligibility</h3>
              <ul className="list-disc ml-6">
                <li>You may request a return within <strong>7 calendar days</strong> from the date of delivery.</li>
                <li>Products must be returned in original condition — unopened, unused, and with all original packaging and documents.</li>
                <li>Returns are not accepted for used, opened, or customer-damaged items unless the defect was hidden at delivery.</li>
              </ul>
            </section>

            {/* 2. Non-Returnable Items */}
            <section>
              <h3 className="text-lg font-semibold mt-6">2. Non-Returnable Items</h3>
              <p>The following items cannot be returned:</p>
              <ul className="list-disc ml-6">
                <li>Products that are used, altered, or damaged after delivery.</li>
                <li>Items without original packaging, documentation, invoice, or accessories.</li>
                <li>Products marked as “non-returnable” on the product page.</li>
              </ul>
            </section>

            {/* 3. Defective or Damaged */}
            <section>
              <h3 className="text-lg font-semibold mt-6">3. Defective or Damaged Products</h3>
              <ul className="list-disc ml-6">
                <li>Report defective or damaged products within <strong>7 days</strong> of delivery.</li>
                <li>Provide photos and a description of the issue.</li>
                <li>We may require the product to be returned for inspection.</li>
                <li>After verification, we may offer a replacement (if in stock) or a full refund.</li>
              </ul>
            </section>

            {/* 4. Exchange */}
            <section>
              <h3 className="text-lg font-semibold mt-6">4. Exchange / Replacement</h3>
              <ul className="list-disc ml-6">
                <li>Contact us if you'd like to exchange your product (e.g., different size/variant).</li>
                <li>Exchanged items must follow return eligibility conditions.</li>
                <li>Price differences (if any) must be paid by you or refunded by us.</li>
              </ul>
            </section>

            {/* 5. Refunds */}
            <section>
              <h3 className="text-lg font-semibold mt-6">5. Refunds</h3>
              <ul className="list-disc ml-6">
                <li>Refunds will be issued to the original payment method used.</li>
                <li>
                  Refund processing may take up to <strong>15 days</strong> after receiving 
                  and inspecting the returned item.
                </li>
                <li>Shipping charges are non-refundable unless the return is due to a defective or incorrect item.</li>
              </ul>
            </section>

            {/* 6. Return Shipping */}
            <section>
              <h3 className="text-lg font-semibold mt-6">6. Return Shipping Costs</h3>
              <ul className="list-disc ml-6">
                <li>Return shipping costs are borne by the customer unless the product is defective, damaged, or incorrect.</li>
                <li>
                  Use a reliable courier service with tracking. You are responsible for the package until we receive it.
                </li>
              </ul>
            </section>

            {/* 7. How to Initiate */}
            <section>
              <h3 className="text-lg font-semibold mt-6">7. How to Initiate a Return / Refund</h3>
              <p>To initiate a return or refund, contact our support team:</p>
              <p className="mt-2">
                <strong>Email:</strong> mpislg21@gmail.com <br />
                <strong>Phone:</strong> 9733228888
              </p>
              <p className="mt-3">Provide:</p>
              <ul className="list-disc ml-6">
                <li>Order ID</li>
                <li>Product name / SKU</li>
                <li>Reason for return</li>
                <li>Photos of the product (if applicable)</li>
                <li>Your preference: refund or replacement</li>
              </ul>
              <p className="mt-3">
                After approval, we will issue a Return Authorization and provide the return address. 
                Once the returned product is received and inspected, your refund or replacement will be processed.
              </p>
            </section>

            {/* 8. Cancellation Policy */}
            <section>
              <h3 className="text-lg font-semibold mt-6">8. Cancellation Policy</h3>
              <ul className="list-disc ml-6">
                <li>You may cancel your order before it has been dispatched.</li>
                <li>If canceled before dispatch, you will receive a full refund.</li>
                <li>
                  If cancellation is requested after dispatch, you must file a return request and return 
                  shipping costs may apply.
                </li>
              </ul>
            </section>

            {/* 9. Contact */}
            <section>
              <h3 className="text-lg font-semibold mt-6">9. Contact Support</h3>
              <p>If you need assistance, please contact:</p>

              <p className="mt-2">
                <strong>MPI Virgin Plastic</strong> <br />
                Siliguri, West Bengal, India <br />
                <strong>Email:</strong> mpislg21@gmail.com <br />
                <strong>Phone:</strong> 9733228888
              </p>
            </section>

          </section>
        </div>
      </MainLayOut>
    </>
  );
};

export default ReturnPolicy;
